import { treaty } from '@elysiajs/eden'
import type { App } from '@porotutu/api/server'
import { clientConfig, origin } from '@porotutu/react/api'

export const client = treaty<App>(origin(), clientConfig)

export const crm = client.api.v1.crm
